import {
    TOGGLE_FILTER_DISPLAY,
    TOGGLE_REQUEST_IN_FLIGHT,
    UPDATE_URI_REF,
    UPDATE_ZIP_CODE,
    type FilterAction,
} from '../actions/filterActions.ts';
import { getQueryParam, addCdnQueryParams } from '../utils/uriUtils.ts';
import { trackFilterChange } from '../utils/tracking/searchBrowse/filterTracking.ts';

const getPage = (generatedUriRef: string): number =>
    parseInt(getQueryParam(generatedUriRef, 'page') ?? '', 10) ||
    parseInt(getQueryParam(generatedUriRef, 'page', true) ?? '', 10) ||
    1;

const initialState = {
    filtersShown: false,
    generatedUriRef: null,
    page: 1,
    refetchInFlight: false,
    zipCode: '0',
    userZipCode: '0',
    hasNewFilterUpdates: false,
};

type FilterReducerState = {
    filtersShown: boolean;
    generatedUriRef: string | null;
    page: number;
    refetchInFlight: boolean;
    zipCode: string;
    userZipCode: string;
    hasNewFilterUpdates: boolean;
};

export function filterReducer(state = initialState, action: FilterAction): FilterReducerState {
    const { type, payload } = action;

    // if a request is in flight, the state is temporarily locked until it completes :
    if (state.refetchInFlight && type !== TOGGLE_REQUEST_IN_FLIGHT) {
        return state;
    }

    switch (type) {
        case TOGGLE_REQUEST_IN_FLIGHT:
            return { ...state, refetchInFlight: payload, hasNewFilterUpdates: true };

        case UPDATE_ZIP_CODE: {
            return {
                ...state,
                ...{ userZipCode: payload, fetchRegionalInfo: true, hasNewFilterUpdates: true },
            };
        }

        case TOGGLE_FILTER_DISPLAY: {
            const filtersShown = typeof payload === 'boolean' ? payload : !state.filtersShown;
            return { ...state, filtersShown, hasNewFilterUpdates: false };
        }

        case UPDATE_URI_REF: {
            const {
                uriRef: generatedUriRef,
                filterName,
                filterValue,
                isFromTypeahead,
                isDeselected,
                ga,
                trackingOptions,
                isDynamic,
                event,
            } = payload || {};
            const newUriRef = generatedUriRef
                ? addCdnQueryParams(generatedUriRef)
                : state.generatedUriRef;
            trackFilterChange({
                filterName,
                filterValue,
                isFromTypeahead,
                isDeselected,
                isDynamic,
                ga,
                trackingOptions,
                event,
            });
            return {
                ...state,
                generatedUriRef: newUriRef,
                page: getPage(newUriRef ?? ''),
            };
        }

        default:
            return state;
    }
}
